import { actionTypes } from '../actions';

const token = (state = null, action) => {
  switch (action.type) {
    case actionTypes.SET_TOKEN:
      return action.token;

    case actionTypes.LOGOUT_USER:
    case actionTypes.CLEAR_TOKEN:
      return null;

    default:
      return state;
  }
};

export default token;



// WEBPACK FOOTER //
// ./src/reducers/token.js